import { authService } from '../App';
import { DbImageData } from '../Models/ImageData/DbImageData';
import { VersionInfoApi } from '../Models/VersionInfo/VersionInfoApi';
import { HttpHelper } from './HttpHelper';

export abstract class ImagesHelper {
  private static baseUrl = HttpHelper.GetUrlBaseApi() + 'api/' + 'Images/';

  public static UploadImage(): string {
    return this.baseUrl + 'UploadImage';
  }

  public static async RemoveImage(id: string) {
    var urlForRequest = this.baseUrl + 'RemoveImage/' + id;
    return await HttpHelper.DeleteRequestForApi(urlForRequest, id, authService.GetToken());
  }

  public static async GetFiles(): Promise<DbImageData[]> {
    var urlForRequest = this.baseUrl + 'AllImagesPaths';
    return await HttpHelper.GetRequestForApi<DbImageData[]>(urlForRequest);
  }
}
